import { render, staticRenderFns } from "./FunnelsItemView.vue?vue&type=template&id=8499ddac&scoped=true"
import script from "./FunnelsItemView.vue?vue&type=script&lang=js"
export * from "./FunnelsItemView.vue?vue&type=script&lang=js"
import style0 from "./FunnelsItemView.vue?vue&type=style&index=0&id=8499ddac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8499ddac",
  null
  
)

export default component.exports